var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenderFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b47f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 8.44615,
    x2: 35.1756,
    xlinkHref: "#a",
    y1: 14.8483,
    y2: -14.7569
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 10.0962,
    x2: 20.5219,
    xlinkHref: "#a",
    y1: 21.2746,
    y2: 6.31685
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19 9c0 3.62-2.74 6.59-6.25 6.96-.25.03-.5.04-.75.04s-.5-.01-.75-.04c-3.51-.37-6.25-3.34-6.25-6.96 0-3.87 3.13-7 7-7s7 3.13 7 7z",
    fill: "url(#b)",
    opacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.75 18.0009c0 .41-.34.75-.75.75h-2.25v2.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2.25h-2.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.25v-1.29c.25.03.5.04.75.04s.5-.01.75-.04v1.29h2.25c.41 0 .75.34.75.75z",
    fill: "url(#c)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderFemale);
export default __webpack_public_path__ + "static/media/gender-female.0f801c71de9ebd2e843c10d897fed889.svg";
export { ForwardRef as ReactComponent };